export default {
  profileMetadata: {
    companyPlaceholder: 'Select company',
    successMessages: {
      changeMetadataUser: 'Profile data has been successfully changed',
      changePhone: 'Phone number successfully changed',
      approveEmail: 'Succesfully approve email',
      changeEmail: 'A confirmation letter has been sent to the specified e-mail',
    },
    errorMessages: {
      changeMetadataUser: 'Failed to change profile data',
      changeAvatar: 'Failed to upload avatar',
      changeSpecialization: 'Failed to change specializations',
      changePhone: 'Failed to change phone number',
      changeEmail: 'Failed to change e-mail',
    },
    changeUserButton: 'Edit my profile',
    accountSettings: 'Account settings',
    formLabels: {
      email: 'New e-mail',
      phone: 'New phone',
      code: 'Code',
    },
    currentUserEmployersDescription: 'Companies where I am listed as an employee',
    userEmployersDescription: 'Companies where the user is listed as an employee',
    noEmployers: 'No employers',
  },
};
